export const TOOLTIP_TRIGGER_NUM = 10000;
export const WAGER_ID_FILTER = 30;
